export default "__VITE_ASSET__DpbeNfUH__"